import { IconButton } from '@mui/material';
import { ConvergeTooltip } from '../../../../presentation/components/converge-tooltip';
import { useRaterActionDispatchContext } from '../data';
import StraightIcon from '@mui/icons-material/Straight';
import SwapVertIcon from '@mui/icons-material/SwapVert';

interface ICascadeFusionScoreModifierButton {
  isFirstRow: boolean;
  isLastRow: boolean;
  fusionScoreModifier: number | null | undefined;
}

export const CascadeFusionScoreModifierButton = ({
  isFirstRow,
  isLastRow,
  fusionScoreModifier,
}: ICascadeFusionScoreModifierButton) => {
  const { dispatch, actions } = useRaterActionDispatchContext();

  return (
    <ConvergeTooltip title="Cascade fusion score modifier">
      <IconButton
        onClick={() => {
          dispatch(
            actions.cascadeFusionScoreModifier(fusionScoreModifier ?? null)
          );
        }}
      >
        {isFirstRow ? (
          <StraightIcon
            sx={{
              transform: 'rotate(180deg)',
            }}
          />
        ) : isLastRow ? (
          <StraightIcon />
        ) : (
          <SwapVertIcon />
        )}
      </IconButton>
    </ConvergeTooltip>
  );
};
